import { connect } from "react-redux";
import { editUser } from "./actions/users";

import Suggestion from "./Suggestion";
import { withRouter } from "react-router-dom";

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { type, id } = ownProps.suggestion;

  return {
    onClick: () => {
      if (type === "user") {
        dispatch(editUser(id));
      } else {
        ownProps.history.push(`/accounts/${id}`);
      }
    }
  };
};

const SuggestionContainer = connect(mapStateToProps, mapDispatchToProps)(
  Suggestion
);

export default withRouter(SuggestionContainer);



// WEBPACK FOOTER //
// ./src/SuggestionContainer.js